import baseApi from "@/lib/redux/api/baseApi";

export const interestedInApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Add Interested In
    addInterestedIn: builder.mutation({
      query: (interestedInData) => ({
        url: "/setting/interested-in/add",
        method: "POST",
        body: interestedInData,
      }),
      invalidatesTags: ['Interested'],
    }),

    // Edit Interested In
    editInterestedIn: builder.mutation({
      query: ({ id, interestedInData }) => ({
        url: `/setting/interested-in/edit/${id}`,
        method: "POST",
        body: interestedInData,
      }),
      invalidatesTags: ['Interested'],
    }),

    // View Interested In
    viewInterestedIn: builder.query({
      query: (id) => ({
        url: `/setting/interested-in/view/${id}`,
        method: "GET",
      }),
      providesTags: ['Interested'],
    }),

    // View Interested In List
    viewInterestedInList: builder.query({
      query: (userId) => ({
        url: `/interested_in/view/list/${userId}`,
        method: "GET",
      }),
      providesTags: ['Interested'],
    }),
      // View Interested In List
    viewLocationList: builder.query({
      query: (userId) => ({
        url: `/user/locations/${userId}`,
        method: "GET",
      }),
      providesTags: ['Interested'],
    }),
    // View "Interested In" list specifically for forms (based on location)
    viewInterestedInListForForms: builder.query({
      query: (userId) => ({
        url: `/interested-in-location/${userId}`,
        method: "GET",
      }),
      providesTags: ['Interested'],
    }),

    // Delete Interested In
    deleteInterestedIn: builder.mutation({
      query: (id) => ({
        url: `/setting/interested-in/delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ['Interested'],
    }),
     updateInterestedInPosition: builder.mutation({
      query: ({ user_id, positions }) => ({
        url: '/setting/interested-in/position/update', 
        method: 'POST',
        body: { user_id, positions },
      }),
    }),
  }),
  overrideExisting: true,
});

// Export hooks
export const {
  useAddInterestedInMutation,
  useEditInterestedInMutation,
  useViewInterestedInQuery,
  useViewInterestedInListQuery,
  useViewLocationListQuery,
  useViewInterestedInListForFormsQuery,
  useDeleteInterestedInMutation,
  useUpdateInterestedInPositionMutation,
} = interestedInApi;
